// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class IdleTimeoutService {

//   constructor() { }
// }
import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "app/core/auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class IdleTimeoutService {
  private timeout: any;
  private readonly idleTime = 40 * 60 * 1000; // 40 minutes in milliseconds
  // private readonly idleTime = 5 * 1000; // 1 minutes in milliseconds

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private auth: AuthService
  ) {
    auth.check().subscribe((val: any) => {
      if (val) {
        this.initListener();
        this.resetTimer();
      }
    });
  }

  private initListener(): void {
    const events = ["click", "mousemove", "keydown", "scroll", "touchstart"];

    events.forEach((event) => {
      window.addEventListener(event, () => this.resetTimer());
    });
  }

  private resetTimer(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.ngZone.runOutsideAngular(() => {
      this.timeout = setTimeout(() => {
        this.ngZone.run(() => {
          this.logout();
        });
      }, this.idleTime);
    });
  }

  private logout(): void {
    // Clear auth/session data here
    localStorage.clear();
    sessionStorage.clear();

    // this.router.navigate(['/login']);
    window.location.href = "/sign-out";
  }
}
